export const ListQueryKey = 'entitys';
export const DetailQueryKey = 'entity';

export const Urls = {
  selectUrl: '/cate/list',
  updateUrl: '/cate/update',
  deleteUrl: '/cate/delete',
  createUrl: '/cate/create',
  detailUrl: '/cate/detail',
};
